export const LOAD = 'ethstats/lastUncles/LOAD';
export const LOAD_SUCCESS = 'ethstats/lastUncles/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/lastUncles/LOAD_FAIL';
